import React from 'react';
import styled from '@emotion/styled';
import { colors } from '@atlaskit/theme';

const Accounts = styled.div`
  > * + * {
    border-top: 1px solid ${colors.N30A} !important;
  }
`;

export default props => <Accounts className="accounts-list">{props.children}</Accounts>;
